// @flow

import React from 'react';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import SolIcon from './sol-icon';

export const sol: CryptocurrencyProtocol = {
  code: 'SOL',
  icon: <SolIcon alt="bep20 icon"/>,
  abbreviation: 'Solana',
  name: 'Solana (SOL)',
};
